export enum FacebookResponseStatus {
  Connected = 'connected',
  NotAuthorized = 'not_authorized',
  Unknown = 'unknown'
}

export interface FacebookLoginParams {
  return_scopes: boolean;
  scope: string;
  auth_type?: 'reauthenticate';
}

export interface FacebookPagePicture {
  data: {
    height: number;
    is_silhouette: boolean;
    url: string;
    width: number;
  };
}

export interface InstagramProfile {
  id: string;
  username: string;
  profile_picture_url: string;
  name: string;
  followers_count: number;
}

export interface FacebookPage {
  picture: FacebookPagePicture;
  name: string;
  name_with_location_descriptor: string;
  access_token: string;
  id: string;
  instagram_business_account?: InstagramProfile;
  tasks: string[];
  followers_count?: number;
}

export interface AccountsResponse {
  data: FacebookPage[];
  error?: {
    message: string;
    type: string;
    code: number;
    error_subcode: number;
    error_user_title: string;
    error_user_msg: string;
    fbtrace_id: string;
  };
  paging?: {
    cursor: {
      after: string;
      before: string;
    };
  };
}

export type InstagramUpgradeModalOptions = {
  /**
   * The text to be displayed in the first paragraph of the modal.
   * Displays a default text if undefined
   * Hides the first paragraph if null
   * @default undefined
   *
   */
  textParagraphA?: string | null;
  /**
   * The text to be displayed in the second paragraph of the modal.
   * Displays a default text if undefined
   * Hides the second paragraph if null
   * @default undefined
   */
  textParagraphB?: string | null;
  /**
   * The text to be displayed in the unlock list of the modal.
   * Displays a default list if undefined
   * Hides the unlock list if null
   * @default undefined
   */
  unlockList?: string[] | null;
  /** Callback for when the modal is closed */
  onClose?: () => void;
};
